export const state = () => ({
  powerBiParams: {},
});
